import API from '../config/api';

// 获取 About Us 内容
export const getAboutUs = async () => {
  try {
    // 尝试获取 About Us 数据
    const response = await API.get('/about-us?populate=*');
    console.log('✅ About Us 获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ 获取 About Us 失败:', error);
    // 返回空数据，让页面显示提示
    return { data: null };
  }
};

// 获取 Contact Us 内容（备用）
export const getContactUs = async () => {
  try {
    const response = await API.get('/contact-us?populate=*');
    return response.data;
  } catch (error) {
    console.error('获取 Contact Us 失败:', error);
    return { data: null };
  }
};
